import ApplePay from './ApplePay';
import PayPal from './PayPal';

export {ApplePay, PayPal};
export default {ApplePay, PayPal};
